module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "ketones-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title"
  }, [_vm._v(_vm._s(_vm.$t('message.cardEmpty')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.latestReadingTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.latest_value + ' ' + _vm.bloodGlucose.unit)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [(_vm.data.last_occurrence) ? _c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.lastOccurrenceTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.data.last_occurrence))
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.totalOccurrenceTitle)
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_occurrence)
    }
  })])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "17px",
      "height": "15px",
      "viewBox": "20 193 17 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.596657,204.024078 L27.4483433,202.008701 C27.4466257,202.00863 27.4449084,202.008558 27.4431913,202.008486 C27.1065685,201.994308 26.7913774,201.899106 26.5165508,201.742332 C26.5127922,201.740187 26.5090412,201.738031 26.5052978,201.735864 L22.9607307,205.098641 C22.9022004,205.00058 22.8320228,204.910144 22.7520541,204.829189 C22.8320477,204.91017 22.9022218,205.000584 22.9607307,205.098603 C23.0858378,205.308123 23.1578576,205.552244 23.1578576,205.813086 C23.1578576,206.591273 22.5192209,207.222113 21.7315461,207.222113 C20.9438714,207.222113 20.3052347,206.591273 20.3052347,205.813086 C20.3052347,205.034899 20.9438714,204.404059 21.7315461,204.404059 C22.0081146,204.404059 22.266129,204.482054 22.4847255,204.616683 C22.5823877,204.676827 22.6721283,204.748294 22.7520786,204.829222 C22.6721112,204.74826 22.5823835,204.676806 22.4847255,204.616683 L25.9804623,201.300249 C25.979853,201.299539 25.9792442,201.298829 25.9786358,201.298118 C25.8510297,201.149012 25.7450446,200.981427 25.6654138,200.799813 C25.6638728,200.796296 25.6623417,200.792774 25.6608205,200.789247 L23.7310234,201.083431 C23.731024,201.083445 23.7310246,201.08346 23.7310252,201.083474 C23.7316689,201.099335 23.7322369,201.115233 23.7322369,201.131281 C23.7322369,201.754564 23.2207519,202.259789 22.5899154,202.259789 C21.9590789,202.259789 21.447594,201.754564 21.447594,201.131281 C21.447594,200.508035 21.9590789,200.002773 22.5899154,200.002773 C23.0588019,200.002773 23.4615755,200.282057 23.6375736,200.681344 C23.6649255,200.743352 23.6867798,200.808249 23.70255,200.875451 C23.686733,200.808242 23.6648749,200.743329 23.6375357,200.681307 L25.5370166,200.391763 C25.5120013,200.265875 25.498617,200.135916 25.498617,200.002773 C25.498617,199.791682 25.531787,199.588223 25.5929395,199.397109 C25.594108,199.393456 25.5952868,199.389807 25.5964758,199.386163 L22.2313526,197.296404 C22.0022118,197.451577 21.7251049,197.542657 21.4263115,197.542657 C20.6386368,197.542657 20,196.911817 20,196.13363 C20,195.355443 20.6386368,194.724603 21.4263115,194.724603 C22.2139862,194.724603 22.852623,195.355443 22.852623,196.13363 C22.852623,196.360693 22.7979454,196.575001 22.701351,196.764993 C22.6977556,196.772067 22.6941018,196.779107 22.6903901,196.786113 L25.9134096,198.787653 C25.9142237,198.786597 25.9150389,198.785541 25.9158551,198.784487 C26.1606166,198.468319 26.498224,198.226405 26.8885399,198.097948 C26.8904269,198.097326 26.8923151,198.096707 26.8942045,198.096091 L26.5419267,196.272088 C26.5275843,196.272616 26.5131743,196.272881 26.4987015,196.272881 C26.0241731,196.272881 25.6173101,195.986976 25.4447199,195.580058 C25.3919735,195.455716 25.3614161,195.320001 25.3572131,195.177778 C25.3569102,195.166631 25.35638,195.155558 25.35638,195.144373 C25.35638,194.521128 25.867865,194.015865 26.4987015,194.015865 C27.129538,194.015865 27.641023,194.521128 27.641023,195.144373 C27.641023,195.609839 27.3557657,196.009462 26.9485713,196.181993 L27.3011865,198.00799 C27.302338,198.007862 27.3034899,198.007735 27.3046421,198.007609 C27.3790096,197.999454 27.4544752,197.99489 27.5310768,197.99489 C27.8205573,197.99489 28.0956868,198.055079 28.3449164,198.162849 C28.3489893,198.16461 28.3530551,198.166383 28.3571139,198.168169 L31.3242218,194.710288 C31.295779,194.66368 31.2706485,194.614875 31.2491522,194.564193 C31.1964058,194.43985 31.1658485,194.304136 31.1616454,194.161913 C31.1613425,194.150766 31.1608124,194.139693 31.1608124,194.128508 C31.1608124,193.505263 31.6722974,193 32.3031339,193 C32.9339704,193 33.4454553,193.505263 33.4454553,194.128508 C33.4454553,194.751791 32.9339704,195.257016 32.3031339,195.257016 C32.1358821,195.257016 31.9770362,195.221499 31.8338911,195.157684 L28.927578,198.544676 C28.9281876,198.545247 28.9287969,198.545817 28.9294058,198.546388 C29.2396504,198.837192 29.4568592,199.223451 29.533072,199.657709 L31.5322182,199.230597 C31.5317163,199.221318 31.5313269,199.21201 31.5310509,199.202673 C31.530748,199.191526 31.5302179,199.180453 31.5302179,199.169268 C31.5302179,198.546023 32.0417029,198.04076 32.6725394,198.04076 C33.3033759,198.04076 33.8148608,198.546023 33.8148608,199.169268 C33.8148608,199.792551 33.3033759,200.297776 32.6725394,200.297776 C32.2080875,200.297776 31.8084578,200.023885 31.6298678,199.63071 L29.5619371,200.072526 C29.5617913,200.076347 29.5616419,200.080166 29.5614918,200.083984 C29.5475952,200.428133 29.4461919,200.749912 29.2784484,201.028261 C29.2780899,201.028856 29.277731,201.02945 29.2773718,201.030045 L33.6347039,203.867711 C33.4627953,204.016368 33.3274646,204.205164 33.2434793,204.419359 L28.8313211,201.546008 C28.8277765,201.548928 28.8242216,201.551836 28.8206565,201.554733 C28.5521534,201.772744 28.2259435,201.923646 27.8681919,201.982675 C27.8668152,201.982902 27.865438,201.983128 27.8640604,201.983353 L28.0113579,203.984385 C28.5960015,204.0338 29.0550808,204.51804 29.0550808,205.108442 C29.0550808,205.731725 28.5435959,206.23695 27.9127594,206.23695 C27.2819229,206.23695 26.7704379,205.731725 26.7704379,205.108442 C26.7704379,204.593604 27.1195928,204.159566 27.5966568,204.024075 Z M27.9622524,203.981169 C27.9787073,203.981941 27.995072,203.983055 28.0113607,203.984422 Z M34.5736885,203.518774 C34.2140057,203.518774 33.8856375,203.650598 33.6347039,203.867711 C33.4627953,204.016443 33.3274646,204.205164 33.2434793,204.419396 C33.1816452,204.577181 33.147377,204.748507 33.147377,204.927838 C33.147377,205.706026 33.7860138,206.336865 34.5736885,206.336865 C35.3613632,206.336865 36,205.706026 36,204.927838 C36,204.149651 35.3613632,203.518774 34.5736885,203.518774 Z",
      "id": "Combined-Shape",
      "stroke": "none",
      "fill": "#2761ff",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    class: {
      invisible: _vm.isOpen
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.bloodGlucose !== false && _vm.isOpenInput === false) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bloodGlucose !== false && _vm.isOpenInput === true) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'remove'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bloodGlucose === false) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": "settings_cog"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToSettings()
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.bloodGlucose.measure === 'mgdl') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "63",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:63',
      "data-vv-name": "ketones_mgdl",
      "data-vv-value-path": _vm.inputValue,
      "data-vv-as": _vm.bloodGlucose.unit,
      "errorText": _vm.errors.first('ketones_mgdl'),
      "label": _vm.$t('message.cardKetones'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.bloodGlucose.unit
    },
    model: {
      value: (_vm.model.mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "mgdl", _vm._n($$v))
      },
      expression: "model.mgdl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bloodGlucose.measure === 'mmoll') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0.1",
      "max": "3.5",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:3.5',
      "data-vv-name": "ketones_mmoll",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.bloodGlucose.unit,
      "errorText": _vm.errors.first('ketones_mmoll'),
      "label": _vm.$t('message.cardKetones'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.bloodGlucose.unit
    },
    model: {
      value: (_vm.model.mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "mmoll", $$v)
      },
      expression: "model.mmoll"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd3e87f8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Input/Ketones/Ketones.vue
// module id = 3845
// module chunks = 1